export default "__VITE_PUBLIC_ASSET__e76a55b5__"